// Public site genel sabitleri.
export const site = {
  name: 'Kapsül',
  fullName: 'Kapsül Teknoloji Platformu',
  // İletişim/footer için (gerektikçe güncellenir).
  email: 'info@kapsulteknolojiplatformu.com',
  social: {
    instagram: 'https://instagram.com/kapsulteknoloji',
    linkedin: 'https://linkedin.com/company/kapsulteknoloji',
    x: 'https://x.com/kapsulteknoloji',
    youtube: 'https://youtube.com/@kapsulteknoloji',
  },
};
